import React from 'react';
import { AdminDataGrid } from '@/admin/shared/AdminDataGrid';
import { useGetUserImportQuery } from '../../../api/userImportsApi';
import { userImportLogColumns } from './columns';

/**
 * A user import's log as a table, from the cached getUserImport: what it did, in order (file
 * accepted, started, each row's outcome, finished or failed), with each entry's time, level
 * and message (userImportLogColumns). The same height as the results table.
 */
export const UserImportLog = ({ importId }) => {
	const { data: userImport } = useGetUserImportQuery(importId);
	// Entries have no id, and only ever get added at the end, so their place is one
	const rows = userImport.log.map((entry, index) => ({ id: index, ...entry }));

	return (
		<AdminDataGrid
			table='userImportLog'
			columns={userImportLogColumns}
			rows={rows}
			objectType='log entries'
			height='50vh'
			maxHeight='50vh'
			showToolbar={false}
			initialState={{ pagination: { paginationModel: { pageSize: 50 } } }}
		/>
	);
};
